module.exports = __webpack_public_path__ + "media/handshake-message/handshake-message1-d4ab51f2.png";